import styled from 'styled-components'

export const CardMinimal = styled.div`
  cursor: pointer;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-height: 252px;
  max-width: 280px;
  min-height: 252px;
  min-width: 280px;
  overflow: hidden;
  position: relative;

  transition: all 0.2s;
  :hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);
  }

  :first-child {
    margin-left: 0;
  }
`

export const CardMinimalLoading = styled(CardMinimal)`
  background: #fff;
`

export const ContentDetail = styled.div`
  align-items: center;
  background: #fff;
  display: flex;
  justify-content: space-between;
  max-height: 52px;
  max-width: 100%;
  min-height: 52px;
  min-width: 100%;
  padding: 8px 16px 12px 16px;
`

export const PartnerToast = styled.div`
  background: var(--secondary-color);
  border-radius: 180px;
  color: #fff;
  font-size: 12px;
  left: 8px;
  padding: 4px 8px;
  position: absolute;
  top: 8px;
  z-index: 2;
`

export const FlagshipToast = styled(PartnerToast)`
  background: var(--primary-color);
`

export const ContentLikeButton = styled.div`
  position: absolute;
  right: 8px;
  top: 8px;
`
